import gql from 'graphql-tag';

export default gql`
    query GetStageSheetProp($stageSheetId: Int) {
        getStageSheetProp(stageSheetId: $stageSheetId) {
            stageSheetProppantId
            proppantName
            totalWeightNeeded
            sandPumped
            totalBoxWeight
            proppantId
        }
    }
`;
